"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _union2 = _interopRequireDefault(require("lodash/union"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var flowKeysToOmit = ['flowSettings', 'isComplete', 'isStarted', 'progressBarGroup', 'showIfOption', 'surveySettings'];
var _default = exports["default"] = function _default(_ref) {
  var flowList = _ref.flowList,
    _ref$onFlowStarted = _ref.onFlowStarted,
    onFlowStarted = _ref$onFlowStarted === void 0 ? function () {} : _ref$onFlowStarted,
    _ref$onFlowComplete = _ref.onFlowComplete,
    onFlowComplete = _ref$onFlowComplete === void 0 ? function () {} : _ref$onFlowComplete,
    _ref$onComplete = _ref.onComplete,
    onComplete = _ref$onComplete === void 0 ? function () {} : _ref$onComplete,
    _ref$onAssignmentComp = _ref.onAssignmentComplete,
    onAssignmentComplete = _ref$onAssignmentComp === void 0 ? function () {} : _ref$onAssignmentComp,
    _ref$onAlreadyComplet = _ref.onAlreadyComplete,
    onAlreadyComplete = _ref$onAlreadyComplet === void 0 ? function () {} : _ref$onAlreadyComplet,
    allowRetake = _ref.allowRetake,
    _ref$mustTakeInOrder = _ref.mustTakeInOrder,
    mustTakeInOrder = _ref$mustTakeInOrder === void 0 ? false : _ref$mustTakeInOrder,
    _ref$enablePrintMode = _ref.enablePrintMode,
    enablePrintMode = _ref$enablePrintMode === void 0 ? false : _ref$enablePrintMode;
  var _useState = (0, _react.useState)(flowList.filter(function (item) {
      return item.isComplete;
    }).map(function (item) {
      return item.handle;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    completedFlows = _useState2[0],
    setCompletedFlows = _useState2[1];
  var _useState3 = (0, _react.useState)(flowList.filter(function (item) {
      return item.isStarted;
    }).map(function (item) {
      return item.handle;
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    startedFlows = _useState4[0],
    setStartedFlows = _useState4[1];
  var _useState5 = (0, _react.useState)((flowList.find(function (item) {
      return !item.isComplete;
    }) || flowList[0]).handle),
    _useState6 = _slicedToArray(_useState5, 2),
    currentFlowHandle = _useState6[0],
    setCurrentFlowHandle = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isEditing = _useState0[0],
    setIsEditing = _useState0[1];
  var currentFlowFromFlowList = flowList.find(function (item) {
    return item.handle === currentFlowHandle;
  });
  (0, _react.useEffect)(function () {
    function checkOnAlreadyComplete() {
      return _checkOnAlreadyComplete.apply(this, arguments);
    }
    function _checkOnAlreadyComplete() {
      _checkOnAlreadyComplete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(!allowRetake && flowList.every(function (item) {
                return item.isComplete;
              }))) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return onAlreadyComplete();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _checkOnAlreadyComplete.apply(this, arguments);
    }
    checkOnAlreadyComplete();
  }, []);
  (0, _react.useEffect)(function () {
    function handleFlowStarted() {
      return _handleFlowStarted.apply(this, arguments);
    }
    function _handleFlowStarted() {
      _handleFlowStarted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              setIsEditing(false);
              _context2.n = 1;
              return onFlowStarted(currentFlowFromFlowList);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return _handleFlowStarted.apply(this, arguments);
    }
    handleFlowStarted();
  }, [currentFlowHandle]);
  var completeCurrentFlow = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            return _context4.a(2, new Promise(/*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(resolve) {
                var allFlowsAreAlreadyCompleted, lastFlowHandle, updatedCompletedFlows, requiredFlows;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      setIsLoading(true);
                      _context3.n = 1;
                      return onFlowComplete(currentFlowFromFlowList);
                    case 1:
                      allFlowsAreAlreadyCompleted = completedFlows.length === flowList.length;
                      lastFlowHandle = flowList[flowList.length - 1].handle;
                      updatedCompletedFlows = (0, _union2["default"])(completedFlows, [currentFlowHandle]);
                      setCompletedFlows(updatedCompletedFlows);
                      requiredFlows = flowList.filter(function (item) {
                        return item.isRequired;
                      });
                      if (!requiredFlows.every(function (item) {
                        return updatedCompletedFlows.includes(item.handle);
                      })) {
                        _context3.n = 2;
                        break;
                      }
                      _context3.n = 2;
                      return onAssignmentComplete();
                    case 2:
                      if (!(updatedCompletedFlows.length === flowList.length && (!allFlowsAreAlreadyCompleted || lastFlowHandle === currentFlowHandle))) {
                        _context3.n = 3;
                        break;
                      }
                      _context3.n = 3;
                      return onComplete();
                    case 3:
                      setIsLoading(false);
                      return _context3.a(2, resolve());
                  }
                }, _callee3);
              }));
              return function (_x) {
                return _ref3.apply(this, arguments);
              };
            }()));
        }
      }, _callee4);
    }));
    return function completeCurrentFlow() {
      return _ref2.apply(this, arguments);
    };
  }();
  var navItems = flowList.map(function (flow) {
    var isCompleted = false;
    var isAllowed = !mustTakeInOrder;
    var isCurrent = false;
    var isNew = false;
    var isStarted = startedFlows.includes(flow.handle);
    if (flow.handle === currentFlowHandle) {
      isCurrent = true;
    }
    if (completedFlows.includes(flow.handle)) {
      isCompleted = true;
      isAllowed = true;
    }
    if (isStarted) {
      isAllowed = true;
    }
    if (!isCurrent && !isCompleted && !isStarted) {
      isNew = true;
    }
    return _objectSpread(_objectSpread({}, (0, _omit2["default"])(flow, flowKeysToOmit)), {}, {
      title: (0, _get2["default"])(flow, 'flowSettings.playerTemplateSettings.title', flow.handle),
      isCompleted: isCompleted,
      isAllowed: isAllowed,
      isCurrent: isCurrent,
      isNew: isNew,
      setCurrent: isAllowed ? function () {
        return setCurrentFlowHandle(flow.handle);
      } : null
    });
  });
  var currentFlowProps = function () {
    var currentFlowIndex = navItems.findIndex(function (item) {
      return item.handle === currentFlowHandle;
    });
    var currentFlow = navItems[currentFlowIndex];
    var nextFlow = navItems[currentFlowIndex + 1];
    var prevFlow = currentFlowIndex > 0 ? navItems[currentFlowIndex - 1] : null;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _omit2["default"])(currentFlow, flowKeysToOmit)), {}, {
      onComplete: function onComplete() {
        return (
          // This promise makes sure all of this finishes before moving on to next flow
          new Promise(/*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(resolve) {
              return _regenerator().w(function (_context5) {
                while (1) switch (_context5.n) {
                  case 0:
                    _context5.n = 1;
                    return completeCurrentFlow();
                  case 1:
                    if (nextFlow) {
                      setStartedFlows([].concat(_toConsumableArray(startedFlows), [nextFlow.handle]));
                      setCurrentFlowHandle(nextFlow.handle);
                    }
                    return _context5.a(2, resolve());
                }
              }, _callee5);
            }));
            return function (_x2) {
              return _ref4.apply(this, arguments);
            };
          }())
        );
      }
    }, prevFlow && {
      goBack: function goBack() {
        setCurrentFlowHandle(prevFlow.handle);
      }
    }), currentFlow.isCompleted && {
      pageFirstElementId: 0
    }), currentFlow.isCompleted && enablePrintMode && {
      isPrintMode: !isEditing
    });
  }();
  return _objectSpread({
    navItems: navItems,
    currentFlowProps: currentFlowProps,
    isLoading: isLoading
  }, currentFlowProps.isCompleted && enablePrintMode && {
    isPrintMode: !isEditing,
    isEditing: isEditing,
    setIsEditing: setIsEditing
  });
};